export default __webpack_public_path__ + "static/media/pos_about_img.62887374.png";